import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Zap } from 'lucide-react';
import { companyInfo, navigationLinks, brandsData } from '../../data/mock';

const Footer = () => {
  return (
    <footer className="bg-[#1a237e] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <img
                src={companyInfo.logo}
                alt={companyInfo.name}
                className="h-16 w-auto object-contain bg-white rounded-lg p-2"
              />
            </div>
            <p className="text-blue-200 text-sm leading-relaxed">
              {companyInfo.tagline}
            </p>
            <div className="flex items-center space-x-2 text-[#c41e3a]">
              <Zap size={18} />
              <span className="text-sm font-medium">Since {companyInfo.since}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white">Quick Links</h3>
            <nav className="space-y-3">
              {navigationLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="block text-blue-200 hover:text-white transition-colors text-sm"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Our Brands */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white">Our Brands</h3>
            <div className="space-y-4">
              <Link to="/products?brand=gulf" className="flex items-center space-x-3 group">
                <img src={brandsData.gulf.logo} alt="Gulf" className="h-8 w-auto bg-white rounded p-1" />
                <span className="text-blue-200 group-hover:text-white transition-colors text-sm">Gulf Batteries</span>
              </Link>
              <Link to="/products?brand=surya" className="flex items-center space-x-3 group">
                <img src={brandsData.surya.logo} alt="Surya" className="h-8 w-auto bg-white rounded p-1" />
                <span className="text-blue-200 group-hover:text-white transition-colors text-sm">Surya Batteries</span>
              </Link>
              <Link to="/products?brand=selenide" className="flex items-center space-x-3 group">
                <img src={brandsData.selenide.logo} alt="Selenide" className="h-8 w-auto bg-white rounded p-1" />
                <span className="text-blue-200 group-hover:text-white transition-colors text-sm">Selenide</span>
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#c41e3a] mt-1 flex-shrink-0" />
                <p className="text-blue-200 text-sm">
                  {companyInfo.contact.address}
                </p>
              </div>
              <div className="flex items-center space-x-3">
                <Phone size={18} className="text-[#c41e3a] flex-shrink-0" />
                <a
                  href={`tel:${companyInfo.contact.phone}`}
                  className="text-blue-200 hover:text-white transition-colors text-sm"
                >
                  +91 {companyInfo.contact.phone}
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={18} className="text-[#c41e3a] flex-shrink-0" />
                <a
                  href={`mailto:${companyInfo.contact.email}`}
                  className="text-blue-200 hover:text-white transition-colors text-sm"
                >
                  {companyInfo.contact.email}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-blue-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-blue-300 text-sm">
              © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
            </p>
            <p className="text-blue-300 text-sm">
              Powering mobility since {companyInfo.since}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
